#import "../fragments/appearance-fragment.graphql"
#import "../fragments/chat-actions-fragment.graphql"

query GetAppearanceSettings {
    chatSettings {
        ...AppearanceFragment
        actions {
            ...ChatActionsFragment
        }
    }
}
